<h1 class="page-title"><span class="user-email">{{ reportData?.userEmail || 'User' }} </span>: Emissions Report</h1>

@if (reportData) {
  <app-emissions-chart [reportData]="reportData"></app-emissions-chart>
}

